<template>
  <div class="List">
    <div class="avt">
      <div class="avt-item" @click="$router.push('/appointment/' + id)">
        参观报名
      </div>
      <div class="avt-item active">活动报名</div>
    </div>
    <div class="List-content">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="activity-item"
        @click="goactivity(item.id)"
      >
        <img :src="item.cover" alt="" width="100%" />
        <div class="name">{{ item.name }}</div>
        <div class="time">{{ item.startDate }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      dataList: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.$axios.get("/book/activList").then((res) => {
      this.dataList = res.data;
    });
  },
  methods: {
    goactivity(id) {
        this.$router.push("/introduce/" + id);
    },
  },
};
</script>
<style lang="less" scoped>
.List {
  min-height: 100%;
  position: relative;
  .avt {
    background-color: #a78d60;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    padding: 0 0.2rem;
    box-sizing: border-box;
    height: 1rem;
    font-size: 0.18rem;
    font-weight: 600;
    .avt-item {
      padding-bottom: 4px;
      color: #ccc;
    }
    .active {
      border-bottom: 3px solid #fff;
      color: #fff;
    }
  }
  .List-content {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    padding-top: 0.3rem;
    .activity-item {
      width: 100%;
      margin-bottom: 0.2rem;
      img {
        border-radius: 0.1rem;
      }
      .name {
        font-size: 0.18rem;
        font-weight: 600;
        margin-top: 0.12rem;
      }
      .time {
        font-size: 0.16rem;
        color: #ccc;
        margin-top: 0.1rem;
      }
    }
  }
}
</style>